import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
const Validator = require('validatorjs')
Validator.useLang('ja')

export default {
  name: 'step-1',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    industryState () {
      return this.company.industry.length > 0
    },
    hpState () {
      let v = new Validator({
        'Webサイト': this.company.hp
      }, {
        'Webサイト': 'required|url'
      })

      let pass = v.passes()
      this.error.hp = v.errors.first('Webサイト')

      return pass
    },
    ipoState () {
      return this.company.ipo === true || this.company.ipo === false
    },
    chargeState () {
      return this.charge.lastName && this.charge.firstName &&
             this.charge.lastNameYomi && this.charge.lastNameYomi &&
             this.charge.department &&
             this.charge.position &&
             this.charge.phone
    },
    presidentState () {
      return this.president.lastName && this.president.firstName &&
             this.president.lastNameYomi && this.president.lastNameYomi
    },
    nextState () {
      return this.name &&
             this.company.yomi &&
             (this.zip_cd && this.prefecture && this.address) &&
             this.hpState &&
             (this.company.phone && this.company.phone.length > 9) &&
             this.company.buildYear &&
             this.ipoState &&
             this.industryState &&
             this.chargeState &&
             this.presidentState
    }
  },
  data () {
    return {
      loading: true,
      updating: false,
      name: '',
      zip_cd: '',
      prefecture: '',
      address: '',
      company: {
        yomi: undefined,
        hp: '',
        phone: undefined,
        buildYear: undefined,
        capital: undefined,
        sales: '選択してください',
        employee: '選択してください',
        ipo: '',
        industry: []
      },
      charge: {
        firstName: '',
        lastName: '',
        firstNameYomi: '',
        lastNameYomi: '',
        phone: '',
        department: '',
        position: ''
      },
      president: {
        firstName: '',
        lastName: '',
        firstNameYomi: '',
        lastNameYomi: ''
      },
      error: {},
      isAlert: false,
      state: {},
      salesOptions: [],
      employeeOptions: [],
      ipoOptions: [
        { value: true, text: 'はい、上場企業です' },
        { value: false, text: 'いいえ、上場企業ではありません' }
      ],
      industryOptions: [],
      industrySelect: '',
      industryDetails: {}
    }
  },
  mounted () {
    let additionalParams = {
      queryParams: {
        type: 'base'
      }
    }

    this.$apig.get(this.api.ENTERPRISE, {}, additionalParams, {})
      .then(response => {
        this.industryOptions = response.data.industryOptions
        this.industryDetails = response.data.industryDetails
        this.salesOptions = response.data.salesOptions
        this.employeeOptions = response.data.employeeOptions
        this.loading = false
      })
      .catch(err => {
        console.log(err)
        this.loading = false
        // TODO エラーページへ遷移
      })
  },
  methods: {
    updateRegister () {
      this.updating = true

      if (!this.nextState) {
        this.error.message = '必須項目を入力してください'
        this.isAlert = true
        window.scrollTo(0, 0)
        this.updating = false
      } else {
        this.isAlert = false

        let additionalParams = {
          queryParams: {
            type: 'register'
          }
        }

        let body = {
          company: this.company,
          name: this.name,
          zip_cd: this.zip_cd,
          prefecture: this.prefecture,
          address: this.prefecture + this.address,
          charge: this.charge,
          president: this.president
        }

        this.$apig.patch(this.api.ENTERPRISE, {}, additionalParams, body)
          .then(response => {
            this.$router.push('/register/step-2')
          })
          .catch(err => {
            console.log(err)
            this.error = err.response.data
            this.isAlert = true
            window.scrollTo(0, 0)
            this.updating = false
          })
      }
    },
    removeIndustry (item, key) {
      this.company.industry.splice(key, '1')
      this.industryDetails[item.industryId.split('-')[0]][item.industryId.split('-')[1]].selected = false
    },
    addIndustry (item, key) {
      this.company.industry.push({
        industryId: `${this.industrySelect}-${item.detail_cd}`,
        detail: item.detail
      })
      this.industryDetails[this.industrySelect][key].selected = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/register/step-1/step-1.js